// extracted by mini-css-extract-plugin
export default {"advertTab":"+m667eaF"};